"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.thenAll = void 0;
var parser_1 = require("@masala/parser");
function thenAll(parsers) {
    var startEmptyTuple = parser_1.F.nop().map(function () { return parser_1.tuple(); });
    return parsers.reduce(function (p, next) { return p.then(next); }, startEmptyTuple);
}
exports.thenAll = thenAll;
//# sourceMappingURL=then-all.js.map